import { render, staticRenderFns } from "./DetailsPanel.vue?vue&type=template&id=5603c0bc"
import script from "./DetailsPanel.vue?vue&type=script&lang=js"
export * from "./DetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./DetailsPanel.vue?vue&type=style&index=0&id=5603c0bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports